import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { LicenseConnectorsSettingsComponent } from '@portal-core/licenses/components/license-connectors/license-connectors-settings/license-connectors-settings.component';
import { SftpFormModule } from '@portal-core/licenses/components/license-connectors/sftp-form/sftp-form.module';
import { SyndicateFormModule } from '@portal-core/licenses/components/license-connectors/syndicate-form/syndicate-form.module';
import { McColorModule } from '@portal-core/ui/themes/directives/mc-color.module';


@NgModule({
  declarations: [
    LicenseConnectorsSettingsComponent
  ],
  imports: [
    McColorModule,
    CommonModule,
    MatIconModule,
    MatSelectModule,
    MatButtonModule,
    SftpFormModule,
    SyndicateFormModule
  ],
  exports: [
    LicenseConnectorsSettingsComponent
  ]
})
export class LicenseConnectorsSettingsModule { }
